"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lineItemFlowCodes = void 0;
var Utils = require("../utils/UtilityFunctions");
var cartUtils = require("../utils/CartUtilFunctions");
var ReportingService_1 = require("./ReportingService");
var CartUtilFunctions_1 = require("../utils/CartUtilFunctions");
var WirelessUtilFunctions_1 = require("../utils/WirelessUtilFunctions");
var ReportingHelperService = /** @class */ (function () {
    function ReportingHelperService() {
    }
    ReportingHelperService.prototype.constructFullUrl = function (path) {
        if (path.includes('http')) {
            return path;
        }
        return window.location.origin + path;
    };
    ReportingHelperService.prototype.getLinkPosition = function (linkNameValue, panelUrl, subPanelPos) {
        if (linkNameValue && (linkNameValue.toLowerCase() === 'close' || (CartUtilFunctions_1.isNewWirelessPostpaidView() &&
            linkNameValue.toLowerCase() === 'delete' || linkNameValue.toLowerCase() === 'update'))) {
            return ReportingService_1.LinkPosition.BODY;
        }
        else {
            var linkPos = subPanelPos.reduce(function (pos, e) { return pos + "_" + e; }, "" + panelUrl.split('/').slice(-1));
            if (['modal', 'thankyou'].includes(linkPos.toLowerCase()) || subPanelPos.includes('body')) {
                return ReportingService_1.LinkPosition.BODY;
            }
            else if (linkPos.startsWith('modal_') || linkPos.startsWith('Modal_')) {
                var position = linkPos.replace('modal_', '').replace('Modal_', '').trim();
                return position;
            }
            else {
                return linkPos;
            }
        }
    };
    ReportingHelperService.prototype.getFormatedAdditionalDetails = function (isFailure, errorId, linkDUrl, currentlinkName, errortype, status, successFlag, linkPos) {
        var finalErrortype = (errorId === '-2') ? undefined : errortype ? errortype :
            ReportingService_1.ErrorTypeOption.Success_Admit;
        var finalStatusMessage = (errorId === '-2') ? 'UNKNOWN' : 'SUCCESS';
        var finalSuccessFlag = successFlag ? successFlag : ReportingService_1.SuccessFlags.SUCCESSFUL;
        if (isFailure) {
            finalErrortype = errortype ? errortype : ReportingService_1.ErrorTypeOption.Failure_System;
            finalStatusMessage = status ? status : errorId;
            finalSuccessFlag = successFlag ? successFlag : ReportingService_1.SuccessFlags.UNSUCCESSFUL;
        }
        var linkPositionUrl = this.getLinkPosition(currentlinkName, linkDUrl, linkPos ? [linkPos] : []);
        return __assign(__assign(__assign(__assign(__assign({}, this.setErrorTypeBasedOnStatus(finalErrortype)), { linkDestinationUrl: (linkDUrl && linkDUrl.includes('/buy/checkout') &&
                !linkDUrl.includes('/modal')) ? '/buy/checkout/checkoutview' : linkDUrl, linkName: currentlinkName, linkPosition: linkPositionUrl }), this.setStatusCodeBasedOnError(errorId)), { statusMessage: finalStatusMessage, successFlag: (finalStatusMessage === 'UNKNOWN') ? ReportingService_1.SuccessFlags.UNKNOWN : finalSuccessFlag }), this.getFlowCodeAndproductType(linkDUrl));
    };
    /*
     * All the flow code references are available in Wiki:
     * https://wiki.web.att.com/pages/viewpage.action?spaceKey=DETS&title=Product+Type+Instrumentation+Guide
     * And DTM reference here: https://wiki.web.att.com/display/DETS/Parameter+Definition+-+page.pageInfo.flowCode
     */
    /*
    * IMPORTANT: The order of the pushing flowcodes and productTypes is not to be changed as the final string should
    * follow the order mentioned in the WIKI page above. Any change to the order or the placement of any new products
    * should be confirmed with analytics team or PO.
    */
    ReportingHelperService.prototype.getFlowCodeAndproductType = function (urlVal) {
        var orderSubType = Utils.getCurrentFlowType();
        orderSubType = orderSubType ? orderSubType.toUpperCase() : undefined;
        var payload = Utils.getCartResp();
        var orderSource = WirelessUtilFunctions_1.externalOrderSource(payload);
        var flowCodeArr = [];
        var productTypeArr = [];
        var lineOfBusiness = 'General';
        var isfirstNetCaribbean = CartUtilFunctions_1.isFNCarribeanUser() ? 'Caribbean' : 'Pacific';
        if (orderSource === 'BMWSMART') {
            flowCodeArr.push(lineItemFlowCodes.EAP_AAL);
            productTypeArr.push('EAP Postpaid Connected Car');
        }
        else if (orderSubType && typeof orderSubType === 'string') {
            /*
                Wireline LOBs
            */
            if (orderSubType.includes('NEW_DTVS')) {
                if (!flowCodeArr.includes(lineItemFlowCodes.WIRELINE_COMMON)) {
                    flowCodeArr.push(lineItemFlowCodes.WIRELINE_COMMON);
                }
                productTypeArr.push('DTV');
                lineOfBusiness = 'Wireline';
            }
            if (orderSubType.includes('NEW_IPTV')) {
                if (!flowCodeArr.includes(lineItemFlowCodes.WIRELINE_COMMON)) {
                    flowCodeArr.push(lineItemFlowCodes.WIRELINE_COMMON);
                }
                productTypeArr.push('IPTV');
                lineOfBusiness = 'Wireline';
            }
            if (orderSubType.includes('NEW_BROADBAND')
                && !Utils.getMigrationSource()) {
                if (!flowCodeArr.includes(lineItemFlowCodes.WIRELINE_COMMON)) {
                    flowCodeArr.push(lineItemFlowCodes.WIRELINE_COMMON);
                }
                if (cartUtils.getIsGigaInCart()) {
                    productTypeArr.push('Fiber Broadband');
                }
                else {
                    productTypeArr.push('Copper Broadband');
                }
                lineOfBusiness = 'Wireline';
            }
            if (orderSubType.includes('NEW_VOIP')) {
                if (!flowCodeArr.includes(lineItemFlowCodes.WIRELINE_COMMON)) {
                    flowCodeArr.push(lineItemFlowCodes.WIRELINE_COMMON);
                }
                productTypeArr.push('Wireline Phone');
                lineOfBusiness = 'Wireline';
            }
            /*
                Postpaid Wireless LOBs
            */
            var eapContext = cartUtils.getEAPDetails();
            var byodFlowCheck = cartUtils.isBYODFlow();
            if (orderSubType.includes('WIRELESS') && (!eapContext.isEAPFlow || eapContext.simType === 'eSIM')) {
                var wirelessLobTypes = cartUtils.getWirlessLineTypes();
                if (orderSubType.includes('NEW_WIRELESS')) {
                    if (!flowCodeArr.includes(lineItemFlowCodes.WIRELESS_NEW)) {
                        flowCodeArr.push(lineItemFlowCodes.WIRELESS_NEW);
                    }
                }
                if (orderSubType.includes('AAL_WIRELESS') || orderSubType.includes('UP_AL_WIRELESS')) {
                    if (!flowCodeArr.includes(lineItemFlowCodes.WIRELESS_AAL)) {
                        flowCodeArr.push(lineItemFlowCodes.WIRELESS_AAL);
                    }
                }
                if (orderSubType.includes('UPGRADE_WIRELESS') || orderSubType.includes('UP_AL_WIRELESS')) {
                    if (!flowCodeArr.includes(lineItemFlowCodes.WIRELESS_UPGRADE)) {
                        flowCodeArr.push(lineItemFlowCodes.WIRELESS_UPGRADE);
                    }
                }
                if (byodFlowCheck.isMixedFlowWithBYOD) {
                    productTypeArr.push('Postpaid|Postpaid BYOD');
                }
                else if (byodFlowCheck.isBYODFlow) {
                    productTypeArr.push('Postpaid BYOD');
                }
                else if (Utils.IsAccessoryOnlyInCart()) {
                    productTypeArr.push('ACCESSORY');
                }
                else if (Utils.isWearableEAPFlow()) {
                    if (Utils.isAppleDevice()) {
                        productTypeArr.push('EAP Postpaid Wearable Apple');
                    }
                    else {
                        productTypeArr.push('EAP Postpaid Wearable Android');
                    }
                }
                else {
                    productTypeArr.push('Postpaid');
                }
            }
            /*
                EAP LOB
            */
            if (eapContext.isEAPFlow && !(eapContext.simType === 'eSIM')) {
                if (eapContext.eapFlowType === 'NEW_EAP' || eapContext.eapFlowType === 'NEW_EAP_ON') {
                    if (!flowCodeArr.includes(lineItemFlowCodes.EAP_NEW)) {
                        flowCodeArr.push(lineItemFlowCodes.EAP_NEW);
                    }
                    if (Utils.isWearableEAPFlow()) {
                        if (Utils.isAppleDevice()) {
                            productTypeArr.push('EAP Postpaid Wearable Apple');
                        }
                        else {
                            productTypeArr.push('EAP Postpaid Wearable Android');
                        }
                    }
                    else if (eapContext.eapFlowType === 'NEW_EAP_ON') {
                        productTypeArr.push('EAP Postpaid On Device');
                    }
                    else {
                        productTypeArr.push('EAP Postpaid Coam');
                    }
                }
                if (eapContext.eapFlowType === 'AAL_EAP' || eapContext.eapFlowType === 'AAL_EAP_ON') {
                    if (!flowCodeArr.includes(lineItemFlowCodes.EAP_AAL)) {
                        flowCodeArr.push(lineItemFlowCodes.EAP_AAL);
                    }
                    if (Utils.isBMWFlow()) {
                        productTypeArr.push('EAP Postpaid Connected Car');
                    }
                    else if (Utils.isWearableEAPFlow()) {
                        if (Utils.isAppleDevice()) {
                            productTypeArr.push('EAP Postpaid Wearable Apple');
                        }
                        else {
                            productTypeArr.push('EAP Postpaid Wearable Android');
                        }
                    }
                    else if (eapContext.eapFlowType === 'AAL_EAP_ON') {
                        productTypeArr.push('EAP Postpaid On Device');
                    }
                    else {
                        productTypeArr.push('EAP Postpaid Coam');
                    }
                }
            }
            /*
                Prepaid Wireless LOBs
            */
            if (orderSubType.includes('PREPAID')) {
                var wirelessLobTypes = cartUtils.getWirlessLineTypes();
                if (!flowCodeArr.includes(lineItemFlowCodes.WIRELESS_PREPAID)) {
                    flowCodeArr.push(lineItemFlowCodes.WIRELESS_PREPAID);
                }
                if (byodFlowCheck.isMixedFlowWithBYOD) {
                    productTypeArr.push('Prepaid|Prepaid BYOD');
                }
                else if (byodFlowCheck.isBYODFlow) {
                    productTypeArr.push('Prepaid BYOD');
                }
                else {
                    productTypeArr.push('Prepaid');
                }
            }
        }
        if (flowCodeArr.length === 0) {
            flowCodeArr.push(lineItemFlowCodes.UNKNOWN);
        }
        return __assign(__assign(__assign(__assign(__assign({}, (CartUtilFunctions_1.isFNIntentPresent() ? ({ 'page.attributes.firstNetGeolocation': isfirstNetCaribbean }) : {})), { 'page.attributes.productType': productTypeArr.join('|'), 'page.attributes.reconnectIndicator': 0, 'page.pageInfo.flowCode': flowCodeArr.join('|'), 'page.pageInfo.lineOfBusiness': lineOfBusiness }), ((Utils === null || Utils === void 0 ? void 0 : Utils.IsBsseFlow()) ? ({ 'page.attributes.billingSytem': 'R' }) : {})), this.getUserAccountInfo()), this.getPageAdditionalInfo(urlVal));
    };
    ReportingHelperService.prototype.getPageAdditionalInfo = function (urlVal) {
        var _a, _b;
        var getViewedUIExperience = window && (window.innerWidth < 768 ? 'Smartphone' : window.innerWidth < 1025 ?
            'Tablet' : 'Desktop');
        var localizationCookie = Utils.getCookie('attPersistantLocalization');
        var zipCode = localizationCookie && (this.getCookieData(localizationCookie, 'zipCode') ?
            this.getCookieData(localizationCookie, 'zipCode') : this.getCookieData(localizationCookie, 'zip'));
        return {
            'page.category.applicationName': 'Digital Sales',
            'page.category.pageFunction': 'Sales',
            'page.category.pageOwnership': 'Consumer',
            'page.category.siteSection': 'myATT Sales',
            'page.location.url': urlVal,
            'page.pageInfo.friendlyPageName': ReportingService_1.notifyFriendlyName[urlVal],
            'page.pageInfo.language': ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href) === null || _b === void 0 ? void 0 : _b.indexOf('es-us')) > -1 ? 'ES' : 'EN',
            'page.pageInfo.responsiveWebDesignFlag': '1',
            'page.pageInfo.viewedUIExperience': getViewedUIExperience,
            'page.pageInfo.zipCode': zipCode,
            'user.uuid': Utils.getCookie('UUID'),
        };
    };
    ReportingHelperService.prototype.getCookieData = function (cookieData, key) {
        var _a, _b, _c;
        var dataVal = '';
        if (cookieData.indexOf('|') > -1) {
            dataVal = (_b = (_a = cookieData === null || cookieData === void 0 ? void 0 : cookieData.split(key + '=')) === null || _a === void 0 ? void 0 : _a[1]) === null || _b === void 0 ? void 0 : _b.split('|')[0];
        }
        else {
            dataVal = (_c = cookieData.split(key + '=')) === null || _c === void 0 ? void 0 : _c[1];
        }
        return dataVal;
    };
    ReportingHelperService.prototype.getRetrievedCartFlag = function () {
        var cartRetFlag = '-2';
        var pageUrl = window.location.href;
        if (pageUrl.includes('sharedCart=true')) {
            cartRetFlag = '1';
        }
        else if (pageUrl.includes('retrieveCart=true')) {
            cartRetFlag = '0';
        }
        if (cartRetFlag !== '-2') {
            return {
                cartRetrievedFlag: cartRetFlag,
            };
        }
        else {
            return {};
        }
    };
    ReportingHelperService.prototype.getACPCartFlag = function () {
        var payload = Utils.getCartResp();
        var isACPVerification = cartUtils.acpVerification();
        var acpSystemError = cartUtils.isAcpSystemError();
        var acpPromo = cartUtils.getAcpEligibilityPromo();
        var acpVerificationAcessPromo = (payload === null || payload === void 0 ? void 0 : payload.acpVerificationforAccessPromo) === true;
        var acpAccessPromo = cartUtils.getAcpAccessPromo();
        var acpIneligibleReason;
        var affordableConnectivityProgramFlag;
        var customerSegment;
        var acpAccessPromotionFlag;
        if (isACPVerification) {
            acpIneligibleReason = 'ACP verification error';
        }
        else if (acpSystemError) {
            acpIneligibleReason = ' ACP System error';
        }
        else if (acpVerificationAcessPromo) {
            acpIneligibleReason = ' ACP Access Promo Verification error';
        }
        else {
            return {};
        }
        if (acpPromo) {
            affordableConnectivityProgramFlag = '1';
        }
        else {
            affordableConnectivityProgramFlag = '0';
        }
        if ((acpPromo === null || acpPromo === void 0 ? void 0 : acpPromo.acpEligibility) === 'TRIBAL') {
            customerSegment = 'Tribal';
        }
        else if ((acpPromo === null || acpPromo === void 0 ? void 0 : acpPromo.acpEligibility) === 'NON_TRIBAL') {
            customerSegment = 'Non-Tribal';
        }
        if ((acpAccessPromo === null || acpAccessPromo === void 0 ? void 0 : acpAccessPromo.isAccessPromo) === true) {
            acpAccessPromotionFlag = '1';
        }
        else {
            acpAccessPromotionFlag = '0';
        }
        return {
            acpAccessPromotionFlag: acpAccessPromotionFlag,
            acpIneligibleReason: acpIneligibleReason,
            affordableConnectivityProgramFlag: affordableConnectivityProgramFlag,
            customerSegment: customerSegment,
        };
    };
    ReportingHelperService.prototype.getUserAccountInfo = function () {
        var _a;
        var payload = Utils.getCartResp();
        var isSMBCustomer = cartUtils.isSMBCustomer();
        var isSMBBBCustomer = !!(((_a = payload === null || payload === void 0 ? void 0 : payload.broadbandCart) === null || _a === void 0 ? void 0 : _a.customerType) === 'SMB');
        var isLoggedInCustomer = Utils.isAuthuser();
        var customerType = '';
        var userType;
        var liabilityType = '';
        var b2bDetail = payload && payload.b2bDetail;
        customerType = isSMBCustomer || isSMBBBCustomer ? 'SMB' : 'CONS';
        var isFirstNetCustomer = CartUtilFunctions_1.isFNIntentPresent();
        if (isLoggedInCustomer) {
            userType = isSMBCustomer ? 'SMB' : 'CONS';
        }
        if (isSMBCustomer) {
            liabilityType = 'CRU';
        }
        else if (!!b2bDetail && !isSMBCustomer) {
            liabilityType = 'IRU';
        }
        else {
            liabilityType = 'CONS';
        }
        if (!!userType) {
            return {
                'user.account.fan': (b2bDetail && b2bDetail.FAN) ? b2bDetail.FAN : '',
                'user.account.liabilityType': liabilityType,
                'user.customerType': customerType,
                'user.firstNetFlag': isFirstNetCustomer ? '1' : '0',
                'user.login.userType': userType,
            };
        }
        else if (!!isSMBCustomer) {
            return {
                'user.account.fan': (b2bDetail && b2bDetail.FAN) ? b2bDetail.FAN : '',
                'user.account.liabilityType': liabilityType,
                'user.customerType': customerType,
            };
        }
        else if (isSMBBBCustomer) {
            return {
                'user.account.liabilityType': 'CRU',
                'user.customerType': customerType,
            };
        }
        else if (!isSMBCustomer && !isSMBBBCustomer) {
            return {
                'user.account.liabilityType': liabilityType,
                'user.customerType': customerType,
                'user.firstNetFlag': isFirstNetCustomer ? '1' : '0',
            };
        }
        else {
            return {};
        }
    };
    ReportingHelperService.prototype.additionalPageLoadData = function (pageTrigger, urlVal) {
        var additionalPageLoadData = this.getFlowCodeAndproductType(urlVal);
        if (pageTrigger) {
            additionalPageLoadData = __assign(__assign({}, additionalPageLoadData), { pageTriggerMethod: pageTrigger });
        }
        return additionalPageLoadData;
    };
    ReportingHelperService.prototype.getfriendlyPageName = function (unauthAccess) {
        if (unauthAccess) {
            return {
                'page.pageInfo.friendlyPageName': 'DS Saved Cart Masked Pg',
            };
        }
        else {
            return {};
        }
    };
    ReportingHelperService.prototype.getCartItemDetails = function (submitAction) {
        if (submitAction === ReportingService_1.EventTypesCodes.SYSTEM_EVENT || submitAction === ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT) {
            var CartInfoApiData = JSON.parse(sessionStorage.getItem('CART:cartInfo'));
            var modifiedCartDetails = this.modifyCartData(CartInfoApiData);
            return modifiedCartDetails;
        }
    };
    // tslint:disable-next-line: no-any
    ReportingHelperService.prototype.modifyCartData = function (cartObj) {
        if (cartObj && !cartObj.items && cartObj.cartItems) {
            cartObj.items = cartObj.cartItems;
            delete cartObj.cartItems;
        }
        return cartObj;
    };
    ReportingHelperService.prototype.isAccountLock = function () {
        var _a, _b;
        if ((Utils === null || Utils === void 0 ? void 0 : Utils.isAuthuser()) && ((_a = Utils === null || Utils === void 0 ? void 0 : Utils.getOrderSubType()) === null || _a === void 0 ? void 0 : _a.includes('WIRELESS'))) {
            return {
                wirelessAccountLockedFlag: ((_b = Utils === null || Utils === void 0 ? void 0 : Utils.getCartResp()) === null || _b === void 0 ? void 0 : _b.isAccountLocked) ? 1 : 0,
            };
        }
    };
    ReportingHelperService.prototype.setStatusCodeBasedOnError = function (errorId) {
        if (errorId) {
            return {
                statusCode: errorId,
            };
        }
        else {
            return {};
        }
    };
    ReportingHelperService.prototype.setErrorTypeBasedOnStatus = function (errorType) {
        if (errorType) {
            return {
                errorType: errorType,
            };
        }
        else {
            return {};
        }
    };
    return ReportingHelperService;
}());
exports.default = ReportingHelperService;
var lineItemFlowCodes;
(function (lineItemFlowCodes) {
    lineItemFlowCodes["WIRELESS_AAL"] = "DSAAL";
    lineItemFlowCodes["WIRELESS_NEW"] = "DSNEW";
    lineItemFlowCodes["ACC_ONLY"] = "DSACC";
    lineItemFlowCodes["WIRELESS_UPGRADE"] = "DSUP";
    lineItemFlowCodes["WIRELESS_PREPAID"] = "DSPREPAID";
    lineItemFlowCodes["WIRELINE_DTVNOW"] = "DSDTVN";
    lineItemFlowCodes["WIRELINE_COMMON"] = "DSPRO";
    lineItemFlowCodes["WIRELINE_IPTVMIGRATION"] = "DSMIG";
    lineItemFlowCodes["EAP_NEW"] = "EANEW";
    lineItemFlowCodes["EAP_AAL"] = "EAAL";
    lineItemFlowCodes["UNKNOWN"] = "DSUNK";
})(lineItemFlowCodes = exports.lineItemFlowCodes || (exports.lineItemFlowCodes = {}));
//# sourceMappingURL=ReportingHelperService.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/api/ReportingHelperService.js
// module id = 1436
// module chunks = 8